import { createElement, forwardRef } from 'react';

interface WeaveInputProps extends React.HTMLAttributes<HTMLElement> {
	disabled?: boolean;
	value?: string | number;
	autocomplete?: string;
	type?: 'text' | 'number' | 'email';
	label?: string;
	name?: string;
	showLabel?: boolean;
	unit?: string;
	step?: string;
	min?: number;
	size?: number;
	variant?: 'box' | 'line';
	max?: number;
	placeholder?: string;
	density?: 'high' | 'medium';
}

export const WeaveInput = forwardRef<HTMLElement, WeaveInputProps>(
	(
		{
			className,
			disabled,
			type,
			label,
			name,
			showLabel,
			unit,
			step,
			min,
			size,
			variant,
			max,
			placeholder,
			density = 'high',
			...rest
		},
		ref
	) => {
		return createElement('weave-input', {
			ref,
			className,
			disabled,
			type,
			label,
			name,
			showLabel,
			unit,
			step,
			min,
			size,
			variant,
			max,
			placeholder,
			density,
			...rest,
		});
	}
);

WeaveInput.displayName = 'WeaveInput';
